import templatesTemplate from './templates.html';

export default angular
  .module('main.organizations.edit.tabs.templates', [])

  .directive('editOrganizationTemplatesTab', () => {
    return {
      restrict: 'E',
      template: templatesTemplate,
      scope: {},
      controller: ($scope,
                   $rootScope,
                   $q,
                   $filter,
                   $timeout,
                   utils,
                   config,
                   ToastsService,
                   UsersService,
                   EditOrganizationDataProvider) => {
        const $t = $filter('translate');

        $scope.emailTemplates = config.getConfigByKey('email-templates');
        $scope.helpers = {
          templateColors: config.getConfigByKey('orgTemplateColors'),
          globalTemplateParams: config.getConfigByKey('orgGlobalTemplate'),
        };

        $scope.dataProvider = EditOrganizationDataProvider.instance;

        angular.extend($scope, {
          defaultColors: true,
          resetColors: resetColors,
          onCancelButtonClick: $scope.dataProvider.goBack,
          saveTemplateParams: saveTemplateParams,
          canSaveTemplates: canSaveTemplates,
          minicolorSetting: {
            control: 'hue',
            theme: 'maestro',
            position: 'bottom left',
            hide: function() {
              saveColors();
            }
          },
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.organizationResource.init(),
            $scope.dataProvider.organizationPropsResource.init(),
          ])
            .then(() => {
              initOrganizationTemplates();
              initWatchers();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
            });
        }

        function initOrganizationTemplates() {
          $scope.orgProperties = angular.copy($scope.dataProvider.organizationPropsResource.value || []);

          // Backup global template params
          $scope.helpers.globalTemplateParamsBackup = angular.copy($scope.helpers.globalTemplateParams);

          // Template colors
          for (let color of $scope.helpers.templateColors) {
            let val = getPropertyByName($scope.orgProperties, color.name);
            if (val != null) {
              color.value = val;
            }
          }

          // Backup colors
          $scope.helpers.templateColorsBackup = angular.copy($scope.helpers.templateColors);
          $scope.defaultColors = compareDefaultColors($scope.helpers.templateColorsBackup);

          // Global template params
          for (let globalParam of $scope.helpers.globalTemplateParams) {
            let val = getPropertyByName($scope.orgProperties, globalParam.name);
            if (val != null) {
              globalParam.value = val;
            }
          }
        }

        function initWatchers() {
          $scope.$watch('helpers.templateColorsBackup', (newValue, oldValue) => {
            if (newValue.length && oldValue.length) {
              let result = newValue.filter(el => !oldValue.find(c => c.value === el.value)).map(c => c.value);
              if (result.length) { // some changes detected
                $scope.defaultColors = compareDefaultColors(newValue);
              }
            }
          });
        }

        /**
         * Compare colors with defaults
         * @param {*} colors
         * @returns {boolean}
         */
        function compareDefaultColors(colors) {
          let defaultColors = config.getConfigByKey('orgTemplateColors');
          let compare = colors.filter(el => !defaultColors.find(c => c.value === el.value)).map(c => c.value);
          return !compare.length;
        }

        function getPropertyByName(orgProperties, name) {
          return utils.getPropertyByName(orgProperties, name, true);
        }

        function canSaveTemplates() {
          for (let i = 0; i < $scope.helpers.globalTemplateParams.length; i++) {
            let param = $scope.helpers.globalTemplateParams[i];
            let paramOrigin = $scope.helpers.globalTemplateParamsBackup[i];
            if (param.value !== paramOrigin.value) {
              return true;
            }
          }
          return false;
        }

        function saveTemplateParams() {
          let properties = [];
          for (let globalParam of $scope.helpers.globalTemplateParams) {
            properties.push({
              'name': globalParam.name,
              'value': globalParam.value,
              'privateContent': false
            });
          }
          saveOrgProperties(properties)
            .then(() => {
              $scope.loading = false;
              ToastsService.success(null, $t('settings.save-global-params-success'));
            });
        }

        function saveColors() {
          let newColors = [];

          for (let i = 0; i < $scope.helpers.templateColors.length; i++) {
            let color = $scope.helpers.templateColors[i];
            let colorOrigin = $scope.helpers.templateColorsBackup[i];
            if (color.value !== colorOrigin.value) {
              newColors.push(color);
            }
          }
          if (newColors && newColors.length > 0) {
            $scope.loading = true;

            saveOrgProperties(newColors)
              .then(() => {
                // Backup colors
                $scope.helpers.templateColorsBackup = angular.copy($scope.helpers.templateColors);

                ToastsService.success(null, $t('settings.save-colors-success'));
                $scope.loading = false;
              }, (err) => {
                $scope.helpers.templateColors = angular.copy($scope.helpers.templateColorsBackup);
                handleError(err);
              });
          }
        }

        function resetColors() {
          $scope.helpers.templateColors = config.getConfigByKey('orgTemplateColors');
          return saveOrgProperties($scope.helpers.templateColors)
            .then(() => {
              // Backup colors
              $scope.helpers.templateColorsBackup = angular.copy($scope.helpers.templateColors);

              ToastsService.success(null, $t('settings.save-colors-success'));
            }, (err) => {
              $scope.helpers.templateColors = angular.copy($scope.helpers.templateColorsBackup);
              handleError(err);
            });
        }

        function saveOrgProperties(props) {
          return $scope.dataProvider.saveOrganizationProps(props)
            .then(() => {
              initOrganizationTemplates();
            })
            .catch((err) => handleError(err));
        }

        /**
         * Handle error and stop loading
         */
        function handleError(err) {
          $scope.loading = false;
          return utils.handleApiError(err);
        }

      }
    };
  })
  .name;
